import { Image } from '@tiptap/extension-image';
import { TableKit } from '@tiptap/extension-table';
import { TextAlign } from '@tiptap/extension-text-align';
import { StarterKit } from '@tiptap/starter-kit';
import isNil from 'lodash/isNil';

import {
  parseRichTextAlignment,
  RICH_TEXT_ALIGN_ATTRIBUTE,
  RICH_TEXT_ALIGNMENTS,
  RICH_TEXT_STARTER_KIT_OPTIONS,
  RICH_TEXT_TABLE_KIT_OPTIONS,
  TEXT_BLOCK_TYPES,
} from '@ui/components/editor/richTextUtils';

// parseHTML is replaced too: stored bodies are re-parsed on every language tab switch.
const RichTextAlign = TextAlign.extend({
  addGlobalAttributes() {
    return [
      {
        types: TEXT_BLOCK_TYPES,
        attributes: {
          textAlign: {
            default: null,
            parseHTML: (element) => parseRichTextAlignment(element.getAttribute(RICH_TEXT_ALIGN_ATTRIBUTE)),
            renderHTML: (attributes) => {
              const alignment = parseRichTextAlignment(attributes.textAlign);
              return isNil(alignment) ? {} : { [RICH_TEXT_ALIGN_ATTRIBUTE]: alignment };
            },
          },
        },
      },
    ];
  },
}).configure({ types: TEXT_BLOCK_TYPES, alignments: RICH_TEXT_ALIGNMENTS });

// Separate from RichTextEditor.tsx and richTextUtils.ts so RichTextContent never bundles ProseMirror.
export const RICH_TEXT_EXTENSIONS = [
  StarterKit.configure(RICH_TEXT_STARTER_KIT_OPTIONS),
  TableKit.configure(RICH_TEXT_TABLE_KIT_OPTIONS),
  Image,
  RichTextAlign,
];
